import React, { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-http-node-configuration";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import {
    Button
} from '@mui/material';

export const WorkflowHTTPNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function handleCloseDialog() {
        context.toggleShowHttpModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance)
        handleCloseDialog();
    }



    const uiSchema: UiSchema = {
        'graphql_query': {
            'ui:widget': 'textarea'
        },
        'graphql_query_params': {
            'ui:widget': 'textarea'
        },
        'raw_body': {
            'ui:widget': 'textarea'
        },
        'json_body': {
            'ui:widget': 'textarea'
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            }
        },
        'ui:order': [
            'url',
            'method',
            'allOf',
            'query_params',
            'authorisation',
            'username',
            'password',
            'token',
            'headers',
            'body',
            'form_data',
            'form_urlencoded',
            'raw_body',
            'json_body',
            'graphql_query',
            'graphql_query_params',
            'data_management',
            'add_output_to_message'
        ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget
    }

    return (
      <DefaultFormDialog
        open={ context.showHttpModal }
        title={ "HTTP Node" }
        handleClose={ handleCloseDialog }
        description={ nodeDescription }
      >
          <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditHttpNode?.id }</span>
          <Form
              validator={validator}
              schema={ formSchema }
              uiSchema={ uiSchema }
              onSubmit={ handleFormSubmit }
              widgets={ widgets }
              id="workflow-if-node-configure"
              formData={ (
                  context.activeEditHttpNode !== undefined &&
                  context.activeEditHttpNode.data !== undefined ?
                      context.activeEditHttpNode.data : undefined
              ) }
          >
              <div className="dialog__actions form-group">
                  <Button type="submit"
                          variant="contained"
                          color="success"
                  >
                      <SaveIcon />
                      <span>{ "Save" }</span>
                  </Button>
                  <Button
                      variant="contained"
                      color="error"
                      onClick={ deleteNode }
                      type="button">
                      <DeleteIcon />
                      <span>{ "Delete" }</span>
                  </Button>
              </div>
          </Form>
      </DefaultFormDialog>
    );
}